import React from 'react'
import {Spinner} from "react-bootstrap"
const Loader = ({show = true}) => {
  if(show){
    return (
			<div className="d-flex justify-content-center">
				<Spinner animation="border" variant="secondary" />
			</div>
		)
  }else{
    return null
  }
}

export default Loader
